import React, { ReactElement } from "react";
import Link from "next/link";
import Image from "@image";
import { useRouter } from "next/router";
//
import LazyImage from "@molecules/layout/Images/LazyImage";
import { NACHU_PLAN_CATEGORIES } from "@src/settings";
import Testimonials from "@organisms/Testimonials/Testimonials";

function WhyInuuaVideo() {
    return (
        <section id="why-use-inuua" className="section section-lg pt-lg-6">
            <div className="container">
                <div className="row justify-content-start mb-lg-5 mb-md-4">
                    <div className="col-12 col-lg-11 col-md-12 text-left px-0 pmx-5 m-auto">
                        <h2 className="h2 font-weight-bolder mb-4">
                            Why Use Inuua to build your Home?
                        </h2>
                    </div>
                </div>
                <div className="row row-grid align-items-center mb-lg-5 mb-md-7">
                    <div className=" align-items-center col-12 col-lg-11 m-auto card shadow-box px-0 mb-0">
                        <div className="embed-responsive embed-responsive-16by9">
                            <iframe
                                src="https://player.vimeo.com/video/651715016?h=01937959b9"
                                frameBorder="0"
                                allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                                allowFullScreen
                                loading="lazy"
                            ></iframe>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}

function InuuaIsMuchMoreThanAHousePlan() {
    return (
        <section
            id="InuuaIsMuchMoreThanAHousePlan"
            className="section section-lg bg-soft py-lg-5 py-3 py-3 "
        >
            <div className="container">
                <div className="row justify-content-center my-5">
                    <h2 className="text-center font-medium font-weight-bold px-2">
                        Inuua na{" "}
                        <a
                            target="_blank"
                            rel="noopener"
                            href="https://www.nachu.or.ke"
                        >
                            NACHU
                        </a>{" "}
                        is an initiative to help people build their own homes,
                        starting with affordable plans, designed for affordable
                        modern luxury function and looks at RiverLine Ridges!
                    </h2>
                </div>
                {/* <div className="container my-5">
                    <div className="rounded-lg">
                        <Image
                        layout="responsive"
                            src="/images/home/house_one.jpg"
                                height={450}
                            width={900}
                            className="inuua-is-more-than-a-house-plan-image"
                        />
                    </div>
                </div> */}
                {/* Explanations  */}
                <div className="container">
                    <div className="row">
                        <div className="col-12 my-3 col-md-6 col-lg-4">
                            <div
                                style={{
                                    height: "375px",
                                    borderRadius: "15px",
                                }}
                                className=" container d-flex flex-column py-2 px-5 bg-dark text-white"
                            >
                                <div className="row mb-3 justify-content-start">
                                    <i className="fas fa-home fa-3x"></i>
                                </div>
                                <div className="row my-1">
                                    <p>
                                        Inuua's mobile platform simplifies home
                                        building by putting all the information
                                        you need to manage your home build on
                                        your smart phone!
                                        <br />
                                        With realistic cost projections, access
                                        to suppliers and tools to manage your
                                        project every step of the way!
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div className="col-12 my-3 col-md-6 col-lg-4">
                            <div
                                style={{
                                    height: "375px",
                                    borderRadius: "15px",
                                }}
                                className="container d-flex flex-column py-2 px-5 bg-white text-dark"
                            >
                                <div className="row mb-3 justify-content-start">
                                    <i className="fas fa-chart-line fa-3x text-dark"></i>
                                </div>
                                <div className="row my-1">
                                    <p>
                                        Inuua na NACHU goes further
                                        <br />
                                        Incorporating the Inuua app that helps
                                        with sourcing material and managing your
                                        project.
                                        <br />
                                        You can request quotes, order and pay
                                        for materials on Inuua as well as
                                        monitor your store and site progress!
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div className="col-12 my-3 col-md-6 col-lg-4">
                            <div
                                style={{
                                    height: "375px",
                                    borderRadius: "15px",
                                }}
                                className="container d-flex flex-column py-2 px-5 bg-white text-dark"
                            >
                                <div className="row mb-3 justify-content-start">
                                    <i className="fas fa-file-invoice-dollar fa-3x "></i>
                                </div>
                                <div className="row my-1">
                                    <p>
                                        Replace rent for affordable repayments
                                        with Inuua CHAP CHAP!
                                    </p>
                                    <ol
                                        style={{
                                            paddingLeft: "25px",
                                            // fontSize: "1rem",
                                        }}
                                    >
                                        <li
                                            style={{
                                                fontSize: "small",
                                            }}
                                        >
                                            Choose an Inuua Chap Chap Plan
                                        </li>
                                        <li
                                            style={{
                                                fontSize: "small",
                                            }}
                                        >
                                            Inuua na NACHU guide you to a
                                            financier{" "}
                                            <small>
                                                *(financier's T&C's apply)
                                            </small>
                                        </li>
                                        <li
                                            style={{
                                                fontSize: "small",
                                            }}
                                        >
                                            Use Inuua's app to manage your home
                                            build within 6 months
                                        </li>
                                        <li
                                            style={{
                                                fontSize: "small",
                                            }}
                                        >
                                            Move in and repay 50k for 3-4 yrs
                                        </li>
                                        <li
                                            style={{
                                                fontSize: "small",
                                            }}
                                        >
                                            Add rooms as you need according to
                                            the plan you have chosen!
                                        </li>
                                    </ol>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}

//
const checkPoints = [
    "Architectural Drawings",
    "Free Project Management Tools on your Phone",
    "Bills of Materials and Labour",
    "All Engineering Drawings",
];

function HousePlans() {
    const router = useRouter();
    return (
        <section
            id="house-types"
            className="section section-lg bg-soft pt-lg-6"
        >
            <div className="container">
                {/* <------------------------------------- checkpoints  ------------------------------------> */}
                <div className="row justify-content-left mb-lg-5 mb-md-5">
                    <h2 className="h2 font-weight-bold mb-4 pmx-5">
                        Available house plans:
                    </h2>
                </div>
                {/* <------------------------------------- end checkpoints  ------------------------------------> */}

                {/* <------------------------------------- house types  ------------------------------------> */}
                <div className="row flex-wrap">
                    {NACHU_PLAN_CATEGORIES.map((houseType, index) => (
                        <div
                            className="col-12 col-lg-4 mb-5 d-flex"
                            key={index}
                        >
                            <div className="card shadow-soft border-light h-100">
                                <div className="card-header p-0 card-header-img">
                                    {/* @ts-ignore */}
                                    <Image
                                        layout="responsive"
                                        src={`/${houseType.image}`}
                                        // webpSrc={`/public/${houseType.image}.webp`}
                                        // wrapperClassName="card-img-top rounded-top"
                                        height={225}
                                        width={350}
                                        quality={50}
                                        // layout="fill"
                                        className="card-img-top rounded-top"
                                        alt={`Inuua ${houseType.name} House Plans, Architectural Drawings, Engineering Drawings and Bills of Materials & Labour`}
                                    />

                                    <div className="img-details shadow-sm">
                                        <div className="pl-4 pt-2">
                                            <span className="h6">
                                                {houseType.name}
                                            </span>
                                        </div>
                                        <div className="pl-4">
                                            <ul className="list-inline">
                                                <li className="list-inline-item">
                                                    <i className="fas fa-bed font-small font-weight-bold"></i>
                                                    &nbsp;
                                                    <span>
                                                        <small>
                                                            {houseType.beds}
                                                        </small>
                                                    </span>
                                                </li>
                                                {houseType.showers &&
                                                houseType.showers.length > 0 ? (
                                                    <li className="list-inline-item">
                                                        <i className="fas fa-bath font-small font-weight-bold"></i>
                                                        &nbsp;
                                                        <span>
                                                            <small>
                                                                {
                                                                    houseType.showers
                                                                }
                                                            </small>
                                                        </span>
                                                    </li>
                                                ) : null}
                                                <li className="list-inline-item">
                                                    <i className="fa fa-money font-small font-weight-bold"></i>
                                                    &nbsp;
                                                    <span>
                                                        <small>
                                                            {houseType.price}
                                                        </small>
                                                    </span>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                                <div className="card-body">
                                    <ul className="list-group d-flex justify-content-center mb-4">
                                        {houseType.points.map((point, idx) => (
                                            <li
                                                className="list-group-item d-flex pl-0 pb-1 pt-0"
                                                key={idx}
                                            >
                                                <span className="mr-2">
                                                    <i className="fas fa-check-circle text-dark"></i>
                                                </span>
                                                {point}
                                            </li>
                                        ))}
                                    </ul>

                                    <Link
                                        href={`${router.asPath}/plans/category/${houseType.slug}`}
                                    >
                                        <a className="analytics-view-plans-link btn btn-dark text-uppercase">
                                            View {houseType.pluralName}
                                        </a>
                                    </Link>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
                {/* <------------------------------------- end house types  ------------------------------------> */}
            </div>
        </section>
    );
}

interface Props {}

function Nachu({}: Props): ReactElement {
    const router = useRouter();
    return (
        <div>
            <section
                id="all-plans-intro"
                className="pt-4 pb-lg-0 mbb-0 bg-white text-dark"
            >
                {/* <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-12 col-lg-8 col-md-8 text-center">
                            <h1 className="font-size-34 mb-3 d-none d-md-block">
                                Inuua na NACHU
                            </h1>
                            <h1 className="font-size-24 mb-3 d-block d-md-none">
                                Inuua na NACHU
                            </h1>
                        </div>
                    </div>
                </div> */}
            </section>

            <div className="container">
                <div className="row  d-flex justify-content-center align-items-center">
                    <div className="col-12 mb-2 p-5 col-md-6 d-flex justify-content-center align-items-center">
                        <Image
                            // layout="responsive"
                            src="/images/nachu/InuuaNaNachuLogo.png"
                            height="150"
                            width="200"
                            className="mr-3"
                            alt="Footer logo"
                            priority
                        />
                    </div>
                    <div className="col-12 mb-2 p-5 col-md-6 d-flex justify-content-center align-items-center">
                        <Image
                            // layout="responsive"
                            src="/images/nachu/RiverLineRidgesLogo.png"
                            height="150"
                            width="200"
                            className="mr-3"
                            alt="Footer logo"
                            priority
                        />
                    </div>
                </div>
            </div>

            {/* <hr /> */}
            <InuuaIsMuchMoreThanAHousePlan />
            <WhyInuuaVideo />
            <HousePlans />

            <section className="bg-dark text-white">
                <div className="container py-4">
                    <div className="row my-5 justify-content-center px-md-5">
                        <h3 className="text-center">Feedback or Questions?</h3>
                    </div>
                    <div className="row my-5 justify-content-center">
                        <div className="col-1  col-lg-3 d-flex justify-content-center">
                            <Image
                                layout="responsive"
                                src="/images/home/dots_small.svg"
                                className=""
                                alt="dots"
                                height={"25px"}
                                width={"200px"}
                            />
                        </div>
                        <div className="col col-md-6 col-lg-3 d-flex justify-content-center">
                            {/* <Link href={`${router.asPath}/express-interest`}> */}
                            <Link href={`/contact`}>
                                <a className=" btn btn-light">
                                    Get in touch with us
                                </a>
                            </Link>
                        </div>
                        <div className="col-1 col-lg-3 d-flex justify-content-center">
                            <Image
                                layout="responsive"
                                src="/images/home/dots_small.svg"
                                className=""
                                alt="dots"
                                height={"25px"}
                                width={"200px"}
                            />
                        </div>
                    </div>
                </div>
            </section>
            {/* 
            <section className="bg-dark text-white">
                <div className="container py-4">
                    <div className="row my-5 justify-content-center px-md-5">
                        <h3 className="text-center">Express your interest</h3>
                    </div>
                    <div className="row my-5 justify-content-center">
                        <div className="col-1  col-lg-3 d-flex justify-content-center">
                            <Image
                            layout="responsive"
                                src="/images/home/dots_small.svg"
                                className=""
                                alt="dots"
                                forceWebP={false}
                                style={{
                                    // height: "150px",
                                    width: "90%",
                                    // objectFit: "cover",
                                }}
                            />
                        </div>
                        <div className="col col-md-6 col-lg-3 d-flex justify-content-center">
                            <Link href={`${router.asPath}/express-interest`}>
                                <a className=" btn btn-light">
                                    I am interested!
                                </a>
                            </Link>
                        </div>
                        <div className="col-1 col-lg-3 d-flex justify-content-center">
                            <Image
                            layout="responsive"
                                src="/images/home/dots_small.svg"
                                className=""
                                alt="dots"
                                forceWebP={false}
                                style={{
                                    // height: "150px",
                                    width: "90%",
                                    // objectFit: "cover",
                                }}
                            />
                        </div>
                    </div>
                </div>
            </section> */}
            <Testimonials />
        </div>
    );
}

export default Nachu;
